import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { ContactServices } from '../services/contact.service';
import { AdminUserService } from './../../adminuser/services/adminuser.service';
import { ContactEdit, CutomerContactsWithLogin } from './../models/contactEdit';
import { ContactType } from './../models/contactView';

@Injectable()
export class ContactEditResolver {
  constructor(private backend: ContactServices) {}
  resolve(route: ActivatedRouteSnapshot) {
    return this.backend.getContactById(+route.params['cid']);
  }
}

@Injectable()
export class ContactTypeResolver {
  constructor(private backend: ContactServices) {}
  resolve() {
    return this.backend.getAllContactType();
  }
}
@Injectable()
export class FunctionListResolver {
  constructor(private backend: ContactServices) {}
  resolve() {
    return this.backend.getAllByFunction();
  }
}
@Injectable()
export class CountryCodeListResolver {
  constructor(private backend: AdminUserService) {}
  resolve() {
    return this.backend.getCountryCodes();
  }
}
@Injectable()
export class CustomerContactsWithLoginResolver
{
  constructor(private backend: ContactServices) {}
  resolve() {
    return this.backend.getAllCustContactsWithLogin();
  }
}
@Injectable()
export class CustomerContactsWithResolver
{
  constructor(private backend: ContactServices) {}
  resolve() {
    return this.backend.getAllCustContacts();
  }
}